import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useTracker } from '../../../context/hooks';
import { SeoRecommendations } from '../../constants';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortenTitleView = ({
  auditResult,
  editorApi
}) => {
  const {
    track
  } = useTracker();
  const {
    status,
    maxTitleLength,
    titleLength
  } = auditResult;
  const handleTrackAction = () => {
    track('clickedFixLink', {
      recommendationType: SeoRecommendations.SHORTEN_TITLE
    });
  };
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    testId: "shorten-title-rec",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.SHORTEN_TITLE"
    }),
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.SHORTEN_TITLE",
      options: {
        maxTitleLength,
        titleLength
      }
    }),
    status: status,
    action: editorApi.shortenPageTitle,
    actionButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.actions.SHORTEN_TITLE"
    }),
    onTrackAction: handleTrackAction
  });
};